var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog',{ref:"dialog",attrs:{"max-width":"450","title":_vm.$t('message.confirm'),"message":_vm.message,"cancel-text":_vm.$t('message.no'),"submit-text":_vm.$t('message.yes')},on:{"submit":function($event){return _vm.submit()}}})}
var staticRenderFns = []

export { render, staticRenderFns }